import MemberCard from "../components/MemberCard";

//admin skins
import Vivtorsing from "../images/skins/Vivtorsing.png";
import DarkMe from "../images/skins/2dark4me.png";
import Pink from "../images/skins/Pink.png";
import Aarielle from "../images/skins/Aarielle.png";
import Gabby from "../images/skins/Gabby.png";
import Julia from "../images/skins/Julia.png";
import Olivia from "../images/skins/Olivia.png";
import Daaiisy from "../images/skins/Daaiisy.png";
import Owner from "../images/skins/Owner.png";
import Cherrytail from "../images/skins/Cherrytail.png";
import CloudForeal from "../images/skins/CloudForeal.png";
import GlitterBunny from "../images/skins/GlitterBunny.png";
import Flowers from "../images/skins/Flowers.png";
import Vivtoria from "../images/skins/Vivtoria.png";

//player skins
import Singh from "../images/skins/Singh.png";
import Jack from "../images/skins/Jack.png";
import Josh from "../images/skins/Josh.png";
import Aroria from "../images/skins/Aroria.png";
import Bob from "../images/skins/Bob.png";
import Sohpie from "../images/skins/Sohpie.png";
import Ignoirant from "../images/skins/Ignoirant.png";
import EpicQuincey from "../images/skins/EpicQuincey.png";
import Sugar from "../images/skins/Sugar.png";
import Kal from "../images/skins/Kal.png";
import Jvnmmy from "../images/skins/Jvnmmy.png";
import Snokri from "../images/skins/Snokri.png";
import King from "../images/skins/King.png";
import MrRaiven from "../images/skins/MrRaiven.png";
import KasiKas from "../images/skins/KasiKas.png";
import Mia from "../images/skins/Mia.png";
import Felisia from "../images/skins/Felisia.png";
import Dinnerbone from "../images/skins/Dinnerbone.png";
import Juicy from "../images/skins/Juicy.png";
import Flpme from "../images/skins/Flpme.png";
import Question from "../images/skins/Question.png";
import Sashimiv from "../images/skins/Sashimiv.png";
import Suzune from "../images/skins/Suzune.png";
import Pelicoco from "../images/skins/Pelicoco.png";
import Sirboxes from "../images/skins/Sirboxes.png";
import Vivia from "../images/skins/Vivia.png";

//more player skins
import Pooja from "../images/skins/Pooja.png";
import Daisy from "../images/skins/Daisy.png";
import Dissociate from "../images/skins/Dissociate.png";
import Vivian from "../images/skins/Vivian.png";
import Mermaid from "../images/skins/Mermaid.png";
import Rainbow from "../images/skins/Rainbow.png";
import Jemma from "../images/skins/Jemma.png";
import Goose from "../images/skins/Goose.png";
import Peach from "../images/skins/Peach.png";

let serverTotal = 120;

const admins = [
  {
    name: "Vivtorsing",
    skin: Vivtorsing,
    lore: "The server creator!"
  },
  {
    name: "Owner",
    skin: Owner,
    lore: "The server owner who takes care of the server!"
  },
  {
    name: "Flowers",
    skin: Flowers,
    lore: "The co owner of the server with Owner! Also involved in some LORE!!!"
  },
  {
    name: "Vivtoria",
    skin: Vivtoria,
    lore: "An admin that grinds on the server and considered to be the most powerful player!"
  },
  {
    name: "2dark4me",
    skin: DarkMe,
    lore: "An Admin that loves gathering materials"
  },
  {
    name: "Pink",
    skin: Pink,
    lore: "An Admin and also Admin for Scale Server"
  },
  {
    name: "Aarielle",
    skin: Aarielle,
    lore: "An admin of the server"
  },
  {
    name: "Gabby",
    skin: Gabby,
    lore: "An admin of the server"
  },
  {
    name: "Julia",
    skin: Julia,
    lore: "The Owner of the Scale Server!",
  },
  {
    name: "Olivia",
    skin: Olivia,
    lore: "The owner of the Cozy Server!",
  },
  {
    name: "Cherrytail",
    skin: Cherrytail,
    lore: "A new admin for the main server"
  },
  {
    name: "Daaiisy",
    skin: Daaiisy,
    lore: "A new admin for the main server"
  },
  {
    name: "CloudForeal",
    skin: CloudForeal,
    lore: "A new admin for the main server"
  },
  {
    name: "Glitter_bunny",
    skin: GlitterBunny,
    lore: "A new admin for the main server"
  }
];

const players = [
  {
    name: "Singh",
    skin: Singh,
    lore: "Loves to read books with LORE!"
  },
  {
    name: "Flpme",
    skin: Flpme,
    lore: "A pirate who loves ships"
  },
  {
    name: "Jack",
    skin: Jack,
    lore: "Flpme best friend"
  },
  {
    name: "???",
    skin: Question,
    lore: "A Villain that went from evil to a city founder"
  },
  {
    name: "Josh",
    skin: Josh,
    lore: "A Secret Spy"
  },
  {
    name: "Aroria",
    skin: Aroria,
    lore: "A player who is in and out and always falls for traps"
  },
  {
    name: "Bob",
    skin: Bob,
    lore: "Loves to hang around with others!"
  },
  {
    name: "Sohpie",
    skin: Sohpie,
    lore: "An extremely powerful villain who almost won. Now uses her powers for good!"
  },
  {
    name: "EpicQuincey",
    skin: EpicQuincey,
    lore: "A powerful ruler that knows what she is doing!"
  },
  {
    name: "Ignoirant",
    skin: Ignoirant,
    lore: "EpicQuincey's sister"
  },
  {
    name: "Sashimiv",
    skin: Sashimiv,
    lore: "A player who loves wolfs!"
  },
  {
    name: "Sugar",
    skin: Sugar,
    lore: "A new player that is lost and confused"
  },
  {
    name: "Kal",
    skin: Kal,
    lore: "The First Villain to actually succeed!"
  },
  {
    name: "Sirboxes",
    skin: Sirboxes,
    lore: "The casino owner and great friends with ???"
  },
  {
    name: "Jvnmmy",
    skin: Jvnmmy,
    lore: "A very powerful villain that was backstabbed."
  },
  {
    name: "Snokri",
    skin: Snokri,
    lore: "A great pvper"
  },
  {
    name: "King",
    skin: King,
    lore: "A good friend of ???"
  },
  {
    name: "MrRaiven",
    skin: MrRaiven,
    lore: "Lives in the End!"
  },
  {
    name: "KasiKas",
    skin: KasiKas,
    lore: "A scientist who is also ??? first friend on the server"
  },
  {
    name: "Mia",
    skin: Mia,
    lore: "Mayor of IRL City"
  },
  {
    name: "Felisia",
    skin: Felisia,
    lore: "The master of making others SUFFER!"
  },
  {
    name: "Suzune",
    skin: Suzune,
    lore: "Sound engineer"
  },
  {
    name: "Dinnerbone",
    skin: Dinnerbone,
    lore: "Lives as a villager"
  },
  {
    name: "Pelicoco",
    skin: Pelicoco,
    lore: "A chill player that loves to farm!"
  },
  {
    name: "Juicy",
    skin: Juicy,
    lore: "Mayor of IRL City"
  },
  {
    name: "Vivia",
    skin: Vivia,
    lore: "A lovely and kind player on the server"
  },
];

const otherPlayers = [
  {
    name: "Goose",
    skin: Goose,
  },
  {
    name: "Pooja",
    skin: Pooja,
  },
  {
    name: "Daisy",
    skin: Daisy,
  },
  {
    name: "Dissociate",
    skin: Dissociate,
  },
  {
    name: "Vivian",
    skin: Vivian,
  },
  {
    name: "Peach",
    skin: Peach,
  },
  {
    name: "Mermaid",
    skin: Mermaid,
  },
  {
    name: "Rainbow",
    skin: Rainbow,
  },
  {
    name: "Jemma",
    skin: Jemma,
  }
];

export default function Members() {
  return (
    <div className="pt-20 px-8">
      <h2 className="text-4xl text-pinky text-center font-bold mb-12">
        💕 Server Members
      </h2>
      <h3 className="text-3xl text-pinky text-center font-bold mb-12">
        Admins
      </h3>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10">
        {admins.map((m) => (
          <MemberCard key={m.name} member={m} />
        ))}
      </div>

      <h3 className="text-3xl text-pinky text-center font-bold mb-12 mt-12">
        Players
      </h3>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10">
        {players.map((m) => (
          <MemberCard key={m.name} member={m} />
        ))}
      </div>

      <h3 className="text-3xl text-pinky text-center font-bold mb-12 mt-12">
        More Players
      </h3>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10">
        {otherPlayers.map((m) => (
          <MemberCard key={m.name} member={m} />
        ))}
      </div>
      
      <h3 className="text-3xl text-pinky text-center font-bold mb-12 mt-12">
        Plus {serverTotal - admins.length - players.length - otherPlayers.length} more players that we haven't added here yet...
      </h3>
    </div>
  );
}

/*
Players
Cop - skip
Sailence - skip
Tany - skip
wolf - skip
Gulfira - skip
Enright - skip
Tanzhen - skip
Vict_ - skip
DotDav - skip
*/